export const DESTINATION_CONFIRM_MESSAGE = {
  onDelete:
    "This action will completely REMOVE channel and may affect LIVE stream. Proceed ?",
  onUpdate:
    "This action will UPDATE channel and may affect LIVE stream. Proceed ?"
};
